import * as React from "react";
import { RichTextInput } from "ra-input-rich-text";
import {
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
  useTranslate,
} from "react-admin";
import RichToolbar from "../creatorsShared/RichToolbar";
import SectionPaper from "../creatorsShared/SectionPaper";
import { formatImage } from "../creatorsShared/formatImage";
import ImageCropInput from "../creatorsShared/imageCrop/ImageCropInput";

const FaqCreatorBuilderForm = () => {
  const [locale] = useLocaleState();
  const translate = useTranslate();

  return (
    <div>
      <SectionPaper title={translate("preview.sections.banner")}>
        <ImageCropInput
          slot="banner"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="banner.bannerImage"
          format={formatImage}
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput
            fullWidth
            source="banner.bannerTitle"
            label="banners.title"
          />
          <TextInput
            fullWidth
            source="banner.bannerSubtitle"
            label="banners.subtitle"
          />
          <ArrayInput source="banner.bannerSlogans" label="banners.slogans">
            <SimpleFormIterator fullWidth>
              <RichTextInput
                toolbar={<RichToolbar />}
                fullWidth
                source="slogan"
                label="banners.slogan"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SectionPaper>

      <SectionPaper title={translate("resources.faq.name")}>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="faq.sectionTitle" label="faq.title" />
          <TextInput
            fullWidth
            source="faq.sectionSubtitle"
            label="faq.subtitle"
          />
          <ArrayInput source="faq.faq" label="faq.questions">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="question" label="faq.question" />
              <RichTextInput
                toolbar={<RichToolbar />}
                fullWidth
                source="answer"
                label="faq.answer"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SectionPaper>
    </div>
  );
};

export default FaqCreatorBuilderForm;
